<template>
  <v-container>
    <footer class="nav-footer">
      <v-divider />
      <template v-for="(paragraph, idx) in footerDisclaimer">
        <p :key="idx">
          <strong>{{ paragraph.label }}</strong>
          &nbsp;<span>{{ paragraph.copy }}</span>
          <span v-if="idx == footerDisclaimer.length - 1">
            <br />
            <v-divider />
          </span>
        </p>
      </template>
      <p>
        &copy; Red Energy Pty Ltd {{ new Date().getFullYear() }} |
        <router-link target="_blank" :to="{ name: 'TermsConditions' }">Terms and Conditions</router-link> |
        <a target="_blank" href="/docs/Privacy-Collection-Commercial-and-Industrial.pdf"> Privacy Policy </a>
      </p>
    </footer>
  </v-container>
</template>

<script>
export default {
  name: 'NavFooter',
  computed: {
    footerDisclaimer() {
      const getDisclaimerKey = routeName => {
        if (
          ['Dashboard', 'Reports', 'MaxDemand', 'Comparison', 'IntervalData', 'IntervalDataViaEmail'].includes(
            routeName
          )
        ) {
          return 'generic'
        }
        return null
      }

      const templates = {
        generic: [
          {
            label: 'Data Latency:',
            copy:
              'Note that data displayed to this C&I Business Customer Portal is at least 48hrs old due to market and system processing timeframes.',
          },
          {
            label: 'Login Email / Password:',

            copy: 'Emails and passwords used to access the Portal cannot be shared with other users.',
          },

          {
            label: 'Meter Data:',

            copy:
              'Meter data consumption may in some instances reflect a slight difference to that which is displayed on your bill. These differences are due to complex market interactions which cannot be replicated within the function of the C&I Business Customer Portal.',
          },

          {
            label: 'Maximum Demand:',

            copy:
              'Maximum Demand shown in the C&I Business Customer Portal is calculated and displayed using a kilowatt per hour calculation over a 30min interval to indicate when your energy consumption is at its highest. Note that not all network tariffs apply a demand charge.',
          },
          {
            label: 'Basic Metered Sites:',

            copy:
              'Interval data is not available for basic metered sites and therefore is not displayed in the dashboard or reporting screens.',
          },
        ],
      }

      return templates[getDisclaimerKey(this.$route.name)] || []
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-footer {
  color: #666666;
  font-size: 14px;
  padding: 25px 16px;
  a {
    color: currentColor;

    &:hover {
      color: $color-primary;
    }
  }
}
</style>
